export default "__VITE_ASSET__d67ebabe__"